const initialState = {
    organizationSelect: null,
}

const AdminReducers = (state = initialState, action) => {
    switch(action.type){
        case 'SELECT_ORGANIZATION_SET':
            return {
                ...state,
                organizationSelect: action.payload,
            }
        case 'SELECT_ORGANIZATION_SHOW':
            // Restituisce lo stato corrente con l'organizationSelect
            return {
                ...state,
                organizationSelect: state.organizationSelect
            };
        default:
            return state;
    }
}

export default AdminReducers;